export class ContactDataModel {

    statusUpdateModel = {
        contactId: null,
        isActive: null
    };

    contactDetails = {
        contactName: null,
        contactType: null,
        primaryPhone: null,
        isInternationalPhone: false,
        email: null,
        contactLinkedAddress:  {
            addressLine1: null,
            addressLine2: null,
            zipCode: null,
            city: null,
            provinceName: null,
            countryName: null
        },
        associatedAccountName: null,
        associatedAccountAddress:  {
            addressLine1: null,
            addressLine2: null,
            zipCode: null,
            city: null,
            provinceName: null,
            countryName: null
        },
        accountActiveSince: null,
        industryName: null,
        accountPhoneNumber: null,
    };

    getFilters(response?: any) {
        return [
            { routerLink: 'all-contacts', text: 'All Contacts', count: response ? response.totalResults : 0 },
            { routerLink: 'added-in-last', text: 'Added in Last 7 days', count: 0 },
            // { routerLink: 'visited-in-last', text: 'Visited in Last 7 days', count: 0 },
            { routerLink: 'modified-in-last', text: 'Modified in Last 7 days', count: 0 },
            // { routerLink: 'converted-to-company', text: 'Converted to company', count: 0 },
            // { routerLink: 'archived-in-last', text: 'Archieved in Last 7 days', count: 0 },
            // { routerLink: 'no-activity-in-last', text: 'No activity in Last Quarter', count: 0 },
        ];
    }

    getFiltersLinks() {
        return {
            All: { label: 'All', link: 'all-contacts'},
            AddedInSevenDays: { label: 'Added in Last 7 days', link: 'added-in-last'},
            ModifiedInSevenDays: { label: 'Modified in Last 7 days', link: 'modified-in-last'}
        }
    }

}
